<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                "branchList" | translate
              }}</span>
            </h3>
            <div class="card-toolbar">
              <!-- Filter btn -->
              <button
                class="btn btn-icon btn-active-light-primary cursor-pointer"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
              >
                <i class="fa-solid fa-filter"></i>
              </button>
              <!-- Create new branch btn -->
              <a
                [routerLink]="['/branch/create']"
                style="margin-left: 30px"
                class="btn btn-sm fw-bold btn-primary"
                >{{ "createNewBranch" | translate }}</a
              >
            </div>
          </div>

          <!-- Branch List -->
          <div class="card-body py-3">
            <div class="table-responsive">
              <!-- Filters -->
              <div class="collapse mb-8" id="collapseExample">
                <form (submit)="filterBranchList($event)">
                  <div class="row">
                    <!-- Name -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="name" class="form-label">{{
                        "name" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.name"
                        type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        placeholder="{{ 'filterByName' | translate }}"
                      />
                    </div>
                    <!-- Customer Code -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="Customer Code" class="form-label">{{
                        "customerCode" | translate
                      }}</label>
                      <select
                        [(ngModel)]="filterForm.customerCode"
                        class="form-select cursor-pointer"
                        aria-label="Small select example"
                        name="Customer Code"
                      >
                        <option [ngValue]="null" selected disabled>
                          {{ "selectCustomerCode" | translate }}
                        </option>
                        <option
                          *ngFor="let customerCode of customerCodes"
                          [value]="customerCode?.code"
                        >
                          {{ customerCode?.code }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- Filter Action Buttons -->
                  <div
                    class="filter-btn mt-2 d-flex align-items-center gap-4 justify-content-end"
                  >
                    <button
                      (click)="clearFilters()"
                      type="button"
                      class="btn btn-secondary btn-sm cursor-pointer"
                    >
                      {{ "clear" | translate }}
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary btn-sm cursor-pointer"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </form>
              </div>
              <!-- Branch Table Loading -->
              <div
                *ngIf="branchListLoading; else branchList"
                class="d-flex justify-content-center pb-4"
              >
                <div class="spinner-border text-danger" role="status">
                  <span class="visually-hidden">branchListLoading...</span>
                </div>
              </div>
              <ng-template #branchList>
                <!-- If no branch available -->
                <div
                  *ngIf="
                    customerBranches && !customerBranches.length;
                    else branchListTable
                  "
                  class="card-body py-3 text-center fs-5"
                >
                  {{ "noBranchesAvailable" | translate }}
                </div>
                <!-- CustomerBranch Table -->
                <ng-template #branchListTable>
                  <table
                    class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"
                  >
                    <thead>
                      <tr class="fw-bold text-muted">
                        <th class="w-25px">
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              data-kt-check="true"
                              data-kt-check-target=".widget-13-check"
                            />
                          </div>
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "name" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "customerCode" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "customerName" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "language" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "createdDate" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-80px fw-bold">
                          {{ "actions" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let branch of customerBranches">
                        <td>
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input widget-13-check"
                              type="checkbox"
                              value="1"
                            />
                          </div>
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ branch.name || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ branch?.customerCode || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ branch?.customerName || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ branch?.languageCode || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{
                            branch?.createdDate
                              ? (branch?.createdDate | date : "dd-MM-yyyy")
                              : "-"
                          }}
                        </td>
                        <td>
                          <!-- Edit Branch -->
                          <a
                            [routerLink]="['/branch/edit', branch?.id]"
                            class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                            ><i class="fa-regular fa-pen-to-square"></i
                          ></a>
                          <!-- Delete Branch -->
                          <a
                            (click)="deleteModalId = branch?.id || ''"
                            data-bs-toggle="modal"
                            [attr.data-bs-target]="
                              '#exampleModal-' + deleteModalId
                            "
                            class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                            ><i class="fa-regular fa-trash-can"></i
                          ></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-template>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="d-flex flex-stack flex-wrap pt-10">
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center">
              <label
                for="pageSizeSelect"
                class="me-2 fs-6 fw-semibold text-gray-700"
                >Page Size:</label
              >
              <select
                id="pageSizeSelect"
                (change)="changePageSize($event)"
                class="cursor-pointer outline-none"
              >
                <option *ngFor="let size of pageSizes" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              Showing {{ customerBranches.length }} of
              {{ totalBranches }} branches
            </div>
          </div>
          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="changePage(currentPage - 1)">
                <i class="previous"></i>
              </a>
            </li>
            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
            </li>
            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="changePage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Branch Modal -->
<div
  class="modal fade"
  [id]="'exampleModal-' + deleteModalId"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="exampleModalLabel">
          {{ "deleteBranch" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "deleteBranchModal" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          (click)="deleteCustomerBranch(deleteModalId)"
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
